import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Controller, useForm } from "react-hook-form";
import logo from "../utils/images/ridePlus.png";
import { useNavigate } from "react-router-dom";
import useTenantBranding from "../hooks/useTenantBranding";
import AuthLayout from "../components/auth/AuthLayout";
import AuthTextField from "../components/auth/AuthTextField";
import PrimaryButton from "../components/auth/PrimaryButton";
import SecondaryButton from "../components/auth/SecondaryButton";

function RecoverPassword() {
  const navigate = useNavigate();
  const { tenantLogo, hideDefaultBranding } = useTenantBranding();

  // USESTATE
  const [openDrawer, setOpenDrawer] = useState(false);
  const [email, setEmail] = useState("");
  // USEFORM HOOK
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  // HELPERS
  const onSubmit = (data) => {
    setEmail(data ? data.email : null);
    setOpenDrawer(true);
  };

  const handleClick = () => {
    navigate("/login");
  };

  const brandingAvatar = (tenantLogo || !hideDefaultBranding) && (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
      <Avatar
        sx={{ width: "100px", height: "80px", borderRadius: 1 }}
        src={tenantLogo || logo}
      />
    </Box>
  );

  // Step 2 — confirmation
  if (openDrawer && email) {
    return (
      <AuthLayout
        title="Recover Password"
        header={brandingAvatar}
        footer={<SecondaryButton onClick={handleClick}>Back to login</SecondaryButton>}
      >
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 15 },
            color: "text.secondary",
            lineHeight: 1.6,
            textAlign: "center",
          }}
        >
          If your account {email} exists, an email will be sent with further
          instructions.
        </Typography>
      </AuthLayout>
    );
  }

  // Step 1 — enter email
  return (
    <AuthLayout
      title="Recover Password"
      header={brandingAvatar}
      onSubmit={handleSubmit(onSubmit)}
      footer={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <PrimaryButton type="submit">Email me a recovery link</PrimaryButton>
          <SecondaryButton onClick={handleClick}>Back to Login</SecondaryButton>
        </Box>
      }
    >
      <Controller
        name="email"
        control={control}
        rules={{
          required: "Email is required",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
        }}
        render={({ field }) => (
          <AuthTextField
            variant="email"
            label="Email Address"
            autoFocus
            error={errors?.email}
            helperText={errors?.email ? errors?.email?.message : ""}
            {...field}
          />
        )}
      />
    </AuthLayout>
  );
}
export default RecoverPassword;
